import { render, staticRenderFns } from "./TableChart.vue?vue&type=template&id=4da4ffab"
import script from "./TableChart.vue?vue&type=script&lang=ts"
export * from "./TableChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports